var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2"},[_c('div',{staticClass:"card m-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_vm._v("Exploratory Dashboard ")]),_c('div',{staticClass:"card-deck m-2"},[(_vm.call)?_vm._l((_vm.homeData),function(r,index){return _c('dc-vizlet',{key:index,attrs:{"dc-viz":r}})}):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }